// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__contentContainer___UIHii {
  padding-top: 32px;
  display: flex;
  gap: 20px;
}
.styles__row___qy7Nz {
}

.styles__caption___zVg1c {
  font-size: 12px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  display: inline-block;
  margin-top: 4px;
  margin-left: 12px;
}

.styles__oneThird___TpNXs {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___TpNXs:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___TpNXs:last-child {
  margin-right: 0;
}

.styles__oneThird___TpNXs:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___TpNXs:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___TpNXs {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___TpNXs:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___TpNXs:last-child {
    margin-right: 0;
}

.styles__oneThird___TpNXs:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___TpNXs:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__twoThird___ibPMv {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__twoThird___ibPMv:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__twoThird___ibPMv:last-child {
  margin-right: 0;
}

.styles__twoThird___ibPMv:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__twoThird___ibPMv:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__twoThird___ibPMv {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__twoThird___ibPMv:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__twoThird___ibPMv:last-child {
    margin-right: 0;
}

.styles__twoThird___ibPMv:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__twoThird___ibPMv:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__cardMarginBot___Hx7a1 {
  /* position: relative; */
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
}
/* .disabledMask {
  height: 100%;
  width: 100%;
  background-color: rgba(128, 128, 128, 0.075);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
} */

.styles__section___G1E32 {
  margin-bottom: 20px;
  position: relative;
}

.styles__section___G1E32 h2 {
    margin-bottom: 20px;
  }

.styles__subSection___VQhjW {
  margin-bottom: 30px;
}

.styles__sectionNoMargin___spFoW {
}

.styles__sectionNoMargin___spFoW h2 {
    margin-bottom: 20px;
  }

.styles__form___e6O89 {
  /* composes: form from helpers; */
}

.styles__formItem___Kd6fV {
}

.styles__formItemHalf___EB0OD {
}

.styles__formItemHalf___EB0OD label {
    font-size: 12px;
  }

/* composes: formItemMono from helpers; */

.styles__formItemMono___D6faU label {
    font-size: 12px;
  }

.styles__input___AmTCZ {
  width: 100% !important;
}

.styles__inputLabelGroup___VPOrg {
  margin-top: 10px;
  margin-bottom: 10px;
}

.styles__inputLabelGroup___VPOrg input {
  margin: 0 10px 20px 4px;
  top: 2px;
  position: relative;
}

.styles__inputLabelGroup___VPOrg label {
  font-size: 12px;
}

.styles__select___ciUxm {
  width: 100% !important;
}

.styles__label___nhKhb {
}

.styles__labelSecondary___smnRd {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
}

.styles__radioButtonGroup___ZOgXE {
}

.styles__radioButtonGroup___ZOgXE label {
  font-size: 12px;
}

.styles__radioButtonGroup___ZOgXE .styles__buttons___Vo1di {
  margin-top: 5px;
}
.styles__checkboxVertical___CEkWj {
  display: flex;
  flex-direction: column;
}

.styles__radioButtonGroup___ZOgXE .styles__buttons___Vo1di input:first-child {
  margin-top: 2px;
  margin-right: 10px;
  margin-left: 0;
}

.styles__radioButtonGroup___ZOgXE .styles__buttons___Vo1di input {
  margin-top: 2px;
  margin-right: 10px;
  margin-left: 20px;
}
.styles__recurringSection___ullE7 {
  margin-top: 12px !important;
}

.styles__submitButtons___hHfSB {
  /* justify-content: right; */
}

.styles__button___fjSLr {
  line-height: 16px !important;
}

.styles__buttonDanger___bBTUr {
  line-height: 16px !important;
}

.styles__searchComponent___EGwgi {
  width: 100%;
}

.styles__payTo___RRaNe {
  padding-top: 10px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.styles__payTo___RRaNe .styles__payToAddress___UI3Ab {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 10px;
    gap: 2px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  }

.styles__payTo___RRaNe .styles__name____UahS {
  font-weight: bold;
  padding-right: 10px;
}

.styles__payTo___RRaNe img {
  margin-bottom: -2px;
}

.styles__fileUpload___bqkf2 {
  width: 100%;
}

.styles__fileUpload___bqkf2 label {
    font-size: 12px;
  }

.styles__fileUploadComponent___qsW_K {
  padding-top: 10px;
}

.styles__textInput___AbmNc {
  width: 100% !important;
}

.styles__textarea___vcPZy {
  background-color: initial;
  min-height: 125px;
  width: 100%;
}

.styles__textareaSmall___YZ5pU {
  background-color: initial;
  min-height: 50px;
  width: 100%;
}

.styles__actions___DmBFt {
  display: grid;
  background: white;
  border-bottom: 0;
  /* stylelint-disable */
  grid-template-columns: repeat(2, 1fr);
  /* stylelint-enable */
  margin-bottom: 20px;
  border-radius: 3px;
}

.styles__actions___DmBFt :nth-child(odd) {
    border-right: 1px solid borderColor;
    border-radius: 3px 0 0 3px;
  }

.styles__actions___DmBFt :nth-child(even) {
    border-radius: 0 3px 3px 0;
  }

.styles__actionButton___YsBI3 {
  display: flex;
  height: 50px;
  color: text;
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10%;
  width: 100%;
  box-shadow: none;
  border-bottom: 1px solid borderColor;
}

.styles__actionButton___YsBI3:hover {
    box-shadow: none;
    background: #f8f8f8;
  }

.styles__distributionFormContainer___pgrUy {
  display: flex;
  gap: 0;
}
.styles__sectionOne___tZ3eS {
  width: calc(99.9% * 34.5/100 - (30px - 30px * 34.5/100));
  margin-right: 0 !important;
  padding-right: 24px !important;
}
.styles__sectionOne___tZ3eS:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__sectionOne___tZ3eS:last-child {
  margin-right: 0;
}
.styles__sectionOne___tZ3eS:nth-child(100n) {
  margin-right: 0;
  float: right;
}
.styles__sectionOne___tZ3eS:nth-child(100n + 1) {
  clear: both;
}
.styles__sectionTwo___pzSZX {
  width: calc(99.9% * 34.5/100 - (30px - 30px * 34.5/100));
  margin-right: 0 !important;
}
.styles__sectionTwo___pzSZX:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__sectionTwo___pzSZX:last-child {
  margin-right: 0;
}
.styles__sectionTwo___pzSZX:nth-child(100n) {
  margin-right: 0;
  float: right;
}
.styles__sectionTwo___pzSZX:nth-child(100n + 1) {
  clear: both;
}
.styles__sectionThree___VfnpU {
  width: calc(99.9% * 4/12 - (30px - 30px * 4/12));
  margin-left: 0 !important;
  position: fixed;
  right: 0;
  top: 151px;
}
.styles__sectionThree___VfnpU:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__sectionThree___VfnpU:last-child {
  margin-right: 0;
}
.styles__sectionThree___VfnpU:nth-child(12n) {
  margin-right: 0;
  float: right;
}
.styles__sectionThree___VfnpU:nth-child(12n + 1) {
  clear: both;
}
.styles__sectionThreeTop___Higqd {
  top: 64px !important;
}
.styles__viewDrfSection___TAKXy {
  width: calc(99.9% * 67/100 - (30px - 30px * 67/100));
}
.styles__viewDrfSection___TAKXy:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__viewDrfSection___TAKXy:last-child {
  margin-right: 0;
}
.styles__viewDrfSection___TAKXy:nth-child(100n) {
  margin-right: 0;
  float: right;
}
.styles__viewDrfSection___TAKXy:nth-child(100n + 1) {
  clear: both;
}

.styles__footerContainer___AgKcW {
  padding-top: 0 !important;
}
.styles__notesList___UIVK2 {
  width: calc(99.9% * 67/100 - (30px - 30px * 67/100));
}
.styles__notesList___UIVK2:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__notesList___UIVK2:last-child {
  margin-right: 0;
}
.styles__notesList___UIVK2:nth-child(100n) {
  margin-right: 0;
  float: right;
}
.styles__notesList___UIVK2:nth-child(100n + 1) {
  clear: both;
}
.styles__bodyAltPaddingTop___sMnrI {
  padding-top: 88px !important;
}

.styles__logInfo___HeL55 {
  width: calc(99.9% * 67/100 - (30px - 30px * 67/100));
  border-top: 1px solid rgba(128, 128, 128, 0.25);
  padding: 0 !important;
}

.styles__logInfo___HeL55:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__logInfo___HeL55:last-child {
  margin-right: 0;
}

.styles__logInfo___HeL55:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__logInfo___HeL55:nth-child(100n + 1) {
  clear: both;
}

.styles__logInfo___HeL55 .styles__logInfoTitle___MPxgW {
    font-size: 14px;
    font-weight: 700;
    color: #31333f;
  }

.styles__logInfo___HeL55 .styles__logList___K2IFv {
    padding: 0;
    list-style: none;
  }

.styles__logInfo___HeL55 .styles__logList___K2IFv li {
      display: flex;
      flex-direction: row;
      gap: 12px;
    }

.styles__logInfo___HeL55 .styles__logList___K2IFv li p {
        margin: 0 0 6px 0;
      }

.styles__logInfoWithoutContainer___d3Mz5 {
  border-top: 1px solid rgba(128, 128, 128, 0.25);
  padding: 0 !important;
  margin-left: -10px;
  width: 96.5%;
}

.styles__logInfoWithoutContainer___d3Mz5 .styles__logInfoTitle___MPxgW {
    font-size: 14px;
    font-weight: 700;
    color: #31333f;
  }

.styles__logInfoWithoutContainer___d3Mz5 .styles__logList___K2IFv {
    padding: 0;
    list-style: none;
  }

.styles__logInfoWithoutContainer___d3Mz5 .styles__logList___K2IFv li {
      display: flex;
      flex-direction: row;
      gap: 12px;
    }

.styles__logInfoWithoutContainer___d3Mz5 .styles__logList___K2IFv li p {
        margin: 0 0 6px 0;
      }

.styles__modalButton___Xu4EK p {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 700;
    color: #31333f;
    margin: 0;
  }

.styles__modalButton___Xu4EK span {
    font-size: 12px;
    font-style: italic;
    color: #31333f;
    display: inline;
  }

.styles__modalButton___Xu4EK span p {
      font-weight: 700;
      font-size: 12px;
      color: #31333f;
      margin: 0;
      text-transform: capitalize;
      display: inline;
    }

.styles__pendingSectionLayout___d7cpD {
  display: flex;
  justify-content: flex-start !important;
  flex-direction: column;
}
.styles__pendingSectionHeader___s42kz p {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 0 !important;
  }
.styles__pendingSectionHeader___s42kz span {
    font-size: 13px;
  }

.styles__checkbox___sYw6N {
  margin-top: 12px;
}

.styles__checkbox___sYw6N p {
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 0 !important;
  }
.styles__radioOption___ch28Q {
  margin-top: 12px;
}
.styles__radioOption___ch28Q input {
    margin-right: 10px;
  }

.styles__submitButtons___hHfSB {
  width: calc(99.9% * 67/100 - (30px - 30px * 67/100));
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.styles__submitButtons___hHfSB:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__submitButtons___hHfSB:last-child {
  margin-right: 0;
}

.styles__submitButtons___hHfSB:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__submitButtons___hHfSB:nth-child(100n + 1) {
  clear: both;
}
.styles__submitButtonsJustify___ll5ng {
  justify-content: space-between !important;
}

.styles__radioClear___vA7n9 {
  background: none;
  outline: none;
  border: none;
  font-size: 12px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
}
.styles__radioClear___vA7n9:hover {
  cursor: pointer;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

.styles__selectedContact___Vk7FD {
  padding-left: 12px;
}
.styles__actionsNeededContainer___jlgmx {
  padding: 20px;
  background-color: white;
}

.styles__xeroLinkItem___b3fR9 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.styles__xeroLinkItem___b3fR9 .styles__xeroItem___mmpJf {
    display: flex;
    gap: 4px;
  }

.styles__xeroLinkItem___b3fR9 .styles__xeroRefresh___lH8Q_:hover {
    -webkit-text-decoration: underline;
    text-decoration: underline;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  }
.styles__xeroRefresh___lH8Q_ {
  font-size: 10px !important;
  -webkit-text-decoration: none;
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;
  opacity: 0.7;
}
.styles__requestorLink___QqwYW {
  position: relative;
  z-index: 11;
  font-size: 10px !important;
  cursor: pointer;
  text-transform: uppercase;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px !important;
}
.styles__requestorLink___QqwYW a {
    box-shadow: none !important;
    opacity: 0.7;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
    -webkit-text-decoration: none;
    text-decoration: none;
  }
.styles__requestorLink___QqwYW a:hover {
    -webkit-text-decoration: underline;
    text-decoration: underline;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  }

.styles__requestor___EXR28 {
  margin-bottom: 6px;
}

.styles__logTableHeader___MSvl7 {
  font-size: 12px !important;
  text-transform: uppercase;
  font-weight: 500;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]} !important;
  color: #31333f !important;
  padding-bottom: 16px !important;
  padding-top: 16px !important;
  padding-left: 20px !important;
}

.styles__logStyle___wAM1E {
  width: 10.25rem !important;
}
.styles__logStyleCell___kxO6a {
  font-size: 11px !important;
  padding: 6px 20px !important;
  line-height: 16px !important;
}

.styles__logStyleCellNoPadding___edpfq {
  font-size: 11px !important;
  line-height: 16px !important;
  padding: 6px 10px !important;
}

.styles__associatedDrfTitle___Qbpa6 {
  font-weight: 600;
}
.styles__scheduledDrfTitle___j0Mir {
  font-weight: 600;
  margin-bottom: 10px;
}
.styles__associatedDrf___vExGf {
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}
.styles__associatedDrfDate___k_tGT {
  display: flex;
  align-items: center;
  gap: 4px;
}
.styles__associatedDrfDate___k_tGT p {
    margin: 6px 0 6px 1px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  }
.styles__requestInfoItem___HlYUJ {
  height: 18px;
  z-index: 10;
  position: relative;
}
.styles__recurringViewLink___ZOHt2 {
  font-size: 12px;
  z-index: 10;
  position: relative;
}

.styles__recurringPaymentWarning___lcoiH {
  margin-top: 0.6rem;
  font-size: 11px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]};
}

.styles__recurringHeader___uomtJ {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleAlt"]} !important;
}

.styles__recurringHeader___uomtJ h5 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleAlt"]} !important;
  }

.styles__recurringDistributionSection___A5ec7 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleLight"]} !important;
}

.styles__requestAmountLabel___LCOF0 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
}

.styles__secondSignerWarning___EvLyf {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  font-weight: 700;
  font-size: 13px;
  margin-top: 2rem;
  margin-bottom: 5rem;
}

.styles__payNowButton___kpWaI {
  display: flex;
  flex-direction: row;
}

.styles__payNowButton___kpWaI p {
    width: calc(99.9% * 4/12 - (30px - 30px * 4/12));
  }

.styles__payNowButton___kpWaI p:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }

.styles__payNowButton___kpWaI p:last-child {
    margin-right: 0;
  }

.styles__payNowButton___kpWaI p:nth-child(12n) {
    margin-right: 0;
    float: right;
  }

.styles__payNowButton___kpWaI p:nth-child(12n + 1) {
    clear: both;
  }

.styles__payNowButton___kpWaI div {
    width: calc(99.9% * 8/12 - (30px - 30px * 8/12));
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

.styles__payNowButton___kpWaI div:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }

.styles__payNowButton___kpWaI div:last-child {
    margin-right: 0;
  }

.styles__payNowButton___kpWaI div:nth-child(12n) {
    margin-right: 0;
    float: right;
  }

.styles__payNowButton___kpWaI div:nth-child(12n + 1) {
    clear: both;
  }

.styles__payNowButton___kpWaI div button {
      width: 110px;
      margin-bottom: 8px;
    }

.styles__payNowButton___kpWaI div button span {
        font-size: 14px !important;
      }

.styles__payNowButton___kpWaI span {
    font-size: 12px;
    font-weight: 400;
    text-align: right;
  }

.styles__orange___SQBmb {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]};
  font-weight: 700;
}

.styles__orange___SQBmb input {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]};
  }

.styles__red___nZygY {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  font-weight: 700;
}

.styles__red___nZygY input {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__feeInfoRow____hnWo {
  display: flex;
  gap: 40px;
  margin-bottom: 24px;
}

.styles__feeInfoItem___qS8hf {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.styles__feeInfoLabel___X9K15 {
  font-size: 12px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  margin-bottom: 4px;
  font-weight: normal;
}

.styles__feeValue___AS4Sa {
  font-weight: 600;
  font-size: 16px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  line-height: 1.2;
}

.styles__enrollmentQuestion___RckoM {
  margin-bottom: 16px;
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
}

.styles__orange___SQBmb {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]};
  font-weight: 600;
  margin-bottom: 16px;
  font-size: 14px;
}

.styles__cardMarginBot___Hx7a1 .styles__sectionNoMargin___spFoW {
  padding: 20px;
}

.styles__feeInfoRow____hnWo:last-child {
  margin-bottom: 0;
}

.styles__italicTextDeposit___HuiFX {
  font-style: italic;
  margin-bottom: 16px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  font-size: 16px;
  font-family: Georgia, 'Times New Roman', serif;
}

.styles__rowError___ftX0Y {
}

.styles__rowError___ftX0Y .styles__error___kfOJW {
    font-weight: bold;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__selectPlaceholder___AjMRE {
  color: #999999 !important;
}

.styles__rowError___ftX0Y {
  margin-top: 8px;
  margin-bottom: 0;
}

.styles__rowError___ftX0Y .styles__error___kfOJW {
    font-weight: bold;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__originalDepositLink___M369J {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  font-weight: bold;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}

.styles__originalDepositLink___M369J:hover {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
}

.styles__recalculateFeeLink___h3wcr {
  -webkit-appearance: none;
          appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin-top: 16px;
  font: inherit;
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  -webkit-text-decoration: underline;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.4;
  align-self: flex-start;
}

.styles__recalculateFeeLink___h3wcr:hover:not(:disabled) {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
}

.styles__recalculateFeeLink___h3wcr:disabled {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  cursor: not-allowed;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.styles__xeroLinks___av_4S {
  display: flex;
  flex-direction: column;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/Main/styles.css"],"names":[],"mappings":"AAIA;EAEE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;AACA;AAEA;;AAEA;EACE,eAAe;EACf,mDAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EAEE,wBAAwB;EACxB,+DAAgC;AAClC;AACA;;;;;;;;GAQG;;AAEH;EAEE,mBAAmB;EACnB,kBAAkB;AAKpB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;AAMA;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,iCAAiC;AACnC;;AAEA;AAEA;;AAEA;AAMA;;AAHE;IACE,eAAe;EACjB;;AAIA,yCAAyC;;AAEzC;IACE,eAAe;EACjB;;AAGF;EAEE,sBAAsB;AACxB;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;AAEA;;AAEA;EAEE,mDAAiB;AACnB;;AAEA;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AAUV;;AATE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,mDAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AAKb;;AAHE;IACE,eAAe;EACjB;;AAGF;EACE,iBAAiB;AACnB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EAEjB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AAUpB;;AARE;IACE,mCAAmC;IACnC,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AAMtC;;AAJE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;AAGF;EAEE,aAAa;EACb,MAAM;AACR;AACA;EACE,wDAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;AAChC;AAJA;EACE,WAAqB;EAArB,kBAAqB;EAArB,WAAqB;AAGvB;AAJA;EACE,eAAqB;AAGvB;AAJA;EACE,eAAqB;EAArB,YAAqB;AAGvB;AAJA;EACE,WAAqB;AAGvB;AACA;EACE,wDAAqB;EACrB,0BAA0B;AAC5B;AAHA;EACE,WAAqB;EAArB,kBAAqB;EAArB,WAAqB;AAEvB;AAHA;EACE,eAAqB;AAEvB;AAHA;EACE,eAAqB;EAArB,YAAqB;AAEvB;AAHA;EACE,WAAqB;AAEvB;AACA;EACE,gDAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;AANA;EACE,WAAiB;EAAjB,kBAAiB;EAAjB,WAAiB;AAKnB;AANA;EACE,eAAiB;AAKnB;AANA;EACE,eAAiB;EAAjB,YAAiB;AAKnB;AANA;EACE,WAAiB;AAKnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oDAAmB;AACrB;AAFA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AACrB;AAFA;EACE,eAAmB;AACrB;AAFA;EACE,eAAmB;EAAnB,YAAmB;AACrB;AAFA;EACE,WAAmB;AACrB;;AAEA;EAEE,yBAAyB;AAC3B;AACA;EACE,oDAAmB;AACrB;AAFA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AACrB;AAFA;EACE,eAAmB;AACrB;AAFA;EACE,eAAmB;EAAnB,YAAmB;AACrB;AAFA;EACE,WAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EAEE,oDAAmB;EACnB,+CAA+C;EAC/C,qBAAqB;AAkBvB;;AAtBA;EAEE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAoBrB;;AAtBA;EAEE,eAAmB;AAoBrB;;AAtBA;EAEE,eAAmB;EAAnB,YAAmB;AAoBrB;;AAtBA;EAEE,WAAmB;AAoBrB;;AAjBE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;AACA;IACE,UAAU;IACV,gBAAgB;EASlB;;AARE;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IAIX;;AAHE;QACE,iBAAiB;MACnB;;AAKN;EAEE,+CAA+C;EAC/C,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AAkBd;;AAjBE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;AACA;IACE,UAAU;IACV,gBAAgB;EASlB;;AARE;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IAIX;;AAHE;QACE,iBAAiB;MACnB;;AAMJ;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;AACA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;EASjB;;AARE;MACE,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,SAAS;MACT,0BAA0B;MAC1B,eAAe;IACjB;;AAIJ;EACE,aAAa;EACb,sCAAsC;EACtC,sBAAsB;AACxB;AAEE;IACE,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;AACA;IACE,eAAe;EACjB;;AAGF;EACE,gBAAgB;AAMlB;;AALE;IACE,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;AAEF;EACE,gBAAgB;AAIlB;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,oDAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAPA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAMrB;;AAPA;EACE,eAAmB;AAMrB;;AAPA;EACE,eAAmB;EAAnB,YAAmB;AAMrB;;AAPA;EACE,WAAmB;AAMrB;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,oDAAgB;AAClB;AACA;EACE,eAAe;EACf,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AAWzB;;AATE;IACE,aAAa;IACb,QAAQ;EACV;;AAEA;IACE,kCAA0B;IAA1B,0BAA0B;IAC1B,mDAAa;EACf;AAEF;EACE,0BAA0B;EAC1B,6BAAqB;EAArB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAW7B;AAVE;IACE,2BAA2B;IAC3B,YAAY;IACZ,mDAAiB;IACjB,6BAAqB;IAArB,qBAAqB;EACvB;AACA;IACE,kCAA0B;IAA1B,0BAA0B;IAC1B,mDAAa;EACf;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,yEAAwC;EACxC,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mDAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AAKV;AAJE;IACE,qBAAqB;IACrB,mDAAgB;EAClB;AAEF;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mDAAmB;AACrB;;AAEA;EACE,yEAAwC;AAI1C;;AAHE;IACE,yEAAwC;EAC1C;;AAGF;EACE,mEAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oDAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AAsBrB;;AArBE;IACE,gDAAiB;EACnB;;AAFA;IACE,WAAiB;IAAjB,kBAAiB;IAAjB,WAAiB;EACnB;;AAFA;IACE,eAAiB;EACnB;;AAFA;IACE,eAAiB;IAAjB,YAAiB;EACnB;;AAFA;IACE,WAAiB;EACnB;;AACA;IACE,gDAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EAQvB;;AAZA;IACE,WAAiB;IAAjB,kBAAiB;IAAjB,WAAiB;EAWnB;;AAZA;IACE,eAAiB;EAWnB;;AAZA;IACE,eAAiB;IAAjB,YAAiB;EAWnB;;AAZA;IACE,WAAiB;EAWnB;;AAPE;MACE,YAAY;MACZ,kBAAkB;IAIpB;;AAHE;QACE,0BAA0B;MAC5B;;AAGJ;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;AAGF;EACE,mDAAmB;EACnB,gBAAgB;AAIlB;;AAHE;IACE,mDAAmB;EACrB;;AAGF;EACE,oDAAY;EACZ,gBAAgB;AAIlB;;AAHE;IACE,oDAAY;EACd;;AAGF;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mDAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mDAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mDAAiB;AACnB;;AAEA;EACE,mDAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mDAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;AAOA;;AAJE;IACE,iBAAiB;IACjB,oDAAY;EACd;;AAGF;EACE,yBAAyB;AAC3B;;AAEA;EAEE,eAAe;EACf,gBAAgB;AAKlB;;AAJE;IACE,iBAAiB;IACjB,oDAAY;EACd;;AAGF;EACE,mDAAa;EACb,iBAAiB;EACjB,kCAA0B;EAA1B,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mDAAiB;AACnB;;AAEA;EACE,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mDAAa;EACb,kCAA0B;EAA1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mDAAiB;AACnB;;AAEA;EACE,mDAAiB;EACjB,mBAAmB;EACnB,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueDark, gtPurpleAlt, gtOrangeDark, gtPurpleLight, gtRed, gtGrayDark, gtGrayLight, gtGrayMid,textLight, gtRedDark, gtCardHeaderBG, gtRed from colors;\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-top: 32px;\n  display: flex;\n  gap: 20px;\n}\n.row {\n  composes: row from helpers;\n}\n\n.caption {\n  font-size: 12px;\n  color: textLight;\n  display: inline-block;\n  margin-top: 4px;\n  margin-left: 12px;\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.twoThird {\n  lost-column: 2/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n  /* position: relative; */\n  background-color: gtCardHeaderBG;\n}\n/* .disabledMask {\n  height: 100%;\n  width: 100%;\n  background-color: rgba(128, 128, 128, 0.075);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n} */\n\n.section {\n  composes: boxWrap from helpers;\n  margin-bottom: 20px;\n  position: relative;\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.subSection {\n  margin-bottom: 30px;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.form {\n  /* composes: form from helpers; */\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n\n  label {\n    font-size: 12px;\n  }\n}\n\n.formItemMono {\n  /* composes: formItemMono from helpers; */\n\n  label {\n    font-size: 12px;\n  }\n}\n\n.input {\n  composes: input from helpers;\n  width: 100% !important;\n}\n\n.inputLabelGroup {\n  composes: clearfix from helpers;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.inputLabelGroup input {\n  margin: 0 10px 20px 4px;\n  top: 2px;\n  position: relative;\n}\n\n.inputLabelGroup label {\n  font-size: 12px;\n}\n\n.select {\n  composes: select from helpers;\n  width: 100% !important;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.labelSecondary {\n  composes: label from helpers;\n  color: gtGrayDark;\n}\n\n.radioButtonGroup {\n  composes: clearfix from helpers;\n}\n\n.radioButtonGroup label {\n  font-size: 12px;\n}\n\n.radioButtonGroup .buttons {\n  margin-top: 5px;\n}\n.checkboxVertical {\n  display: flex;\n  flex-direction: column;\n}\n\n.radioButtonGroup .buttons input:first-child {\n  margin-top: 2px;\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n.radioButtonGroup .buttons input {\n  margin-top: 2px;\n  margin-right: 10px;\n  margin-left: 20px;\n}\n.recurringSection {\n  margin-top: 12px !important;\n}\n\n.submitButtons {\n  composes: buttons from helpers;\n  /* justify-content: right; */\n}\n\n.button {\n  composes: button from helpers;\n  line-height: 16px !important;\n}\n\n.buttonDanger {\n  composes: buttonDanger from helpers;\n  line-height: 16px !important;\n}\n\n.searchComponent {\n  width: 100%;\n}\n\n.payTo {\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  .payToAddress {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    font-size: 10px;\n    gap: 2px;\n    color: gtGrayDark;\n  }\n}\n\n.payTo .name {\n  font-weight: bold;\n  padding-right: 10px;\n}\n\n.payTo img {\n  margin-bottom: -2px;\n}\n\n.fileUpload {\n  width: 100%;\n\n  label {\n    font-size: 12px;\n  }\n}\n\n.fileUploadComponent {\n  padding-top: 10px;\n}\n\n.textInput {\n  composes: input from helpers;\n  width: 100% !important;\n}\n\n.textarea {\n  composes: textarea from helpers;\n  background-color: initial;\n  min-height: 125px;\n  width: 100%;\n}\n\n.textareaSmall {\n  composes: textarea from helpers;\n  background-color: initial;\n  min-height: 50px;\n  width: 100%;\n}\n\n.actions {\n  display: grid;\n  background: white;\n  composes: card from helpers;\n  border-bottom: 0;\n  /* stylelint-disable */\n  grid-template-columns: repeat(2, 1fr);\n  /* stylelint-enable */\n  margin-bottom: 20px;\n  border-radius: 3px;\n\n  :nth-child(odd) {\n    border-right: 1px solid borderColor;\n    border-radius: 3px 0 0 3px;\n  }\n\n  :nth-child(even) {\n    border-radius: 0 3px 3px 0;\n  }\n}\n\n.actionButton {\n  display: flex;\n  height: 50px;\n  color: text;\n  font-weight: 600;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 10%;\n  width: 100%;\n  box-shadow: none;\n  border-bottom: 1px solid borderColor;\n\n  &:hover {\n    box-shadow: none;\n    background: #f8f8f8;\n  }\n}\n\n.distributionFormContainer {\n  composes: content-container from helpers;\n  display: flex;\n  gap: 0;\n}\n.sectionOne {\n  lost-column: 34.5/100;\n  margin-right: 0 !important;\n  padding-right: 24px !important;\n}\n.sectionTwo {\n  lost-column: 34.5/100;\n  margin-right: 0 !important;\n}\n.sectionThree {\n  lost-column: 4/12;\n  margin-left: 0 !important;\n  position: fixed;\n  right: 0;\n  top: 151px;\n}\n.sectionThreeTop {\n  top: 64px !important;\n}\n.viewDrfSection {\n  lost-column: 67/100;\n}\n\n.footerContainer {\n  composes: content-container from helpers;\n  padding-top: 0 !important;\n}\n.notesList {\n  lost-column: 67/100;\n}\n.bodyAltPaddingTop {\n  padding-top: 88px !important;\n}\n\n.logInfo {\n  composes: content-container from helpers;\n  lost-column: 67/100;\n  border-top: 1px solid rgba(128, 128, 128, 0.25);\n  padding: 0 !important;\n  .logInfoTitle {\n    font-size: 14px;\n    font-weight: 700;\n    color: #31333f;\n  }\n  .logList {\n    padding: 0;\n    list-style: none;\n    li {\n      display: flex;\n      flex-direction: row;\n      gap: 12px;\n      p {\n        margin: 0 0 6px 0;\n      }\n    }\n  }\n}\n\n.logInfoWithoutContainer {\n  composes: content-container from helpers;\n  border-top: 1px solid rgba(128, 128, 128, 0.25);\n  padding: 0 !important;\n  margin-left: -10px;\n  width: 96.5%;\n  .logInfoTitle {\n    font-size: 14px;\n    font-weight: 700;\n    color: #31333f;\n  }\n  .logList {\n    padding: 0;\n    list-style: none;\n    li {\n      display: flex;\n      flex-direction: row;\n      gap: 12px;\n      p {\n        margin: 0 0 6px 0;\n      }\n    }\n  }\n}\n\n.modalButton {\n  p {\n    font-size: 16px;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: #31333f;\n    margin: 0;\n  }\n  span {\n    font-size: 12px;\n    font-style: italic;\n    color: #31333f;\n    display: inline;\n    p {\n      font-weight: 700;\n      font-size: 12px;\n      color: #31333f;\n      margin: 0;\n      text-transform: capitalize;\n      display: inline;\n    }\n  }\n}\n\n.pendingSectionLayout {\n  display: flex;\n  justify-content: flex-start !important;\n  flex-direction: column;\n}\n.pendingSectionHeader {\n  p {\n    font-weight: 600;\n    font-size: 16px;\n    margin-bottom: 0 !important;\n  }\n  span {\n    font-size: 13px;\n  }\n}\n\n.checkbox {\n  margin-top: 12px;\n  p {\n    font-weight: 600;\n    font-size: 13px;\n    margin-bottom: 0 !important;\n  }\n}\n.radioOption {\n  margin-top: 12px;\n  input {\n    margin-right: 10px;\n  }\n}\n\n.submitButtons {\n  lost-column: 67/100;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.submitButtonsJustify {\n  justify-content: space-between !important;\n}\n\n.radioClear {\n  background: none;\n  outline: none;\n  border: none;\n  font-size: 12px;\n  color: gtRedDark;\n}\n.radioClear:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.selectedContact {\n  padding-left: 12px;\n}\n.actionsNeededContainer {\n  padding: 20px;\n  background-color: white;\n}\n\n.xeroLinkItem {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  .xeroItem {\n    display: flex;\n    gap: 4px;\n  }\n\n  .xeroRefresh:hover {\n    text-decoration: underline;\n    color: gtBlue;\n  }\n}\n.xeroRefresh {\n  font-size: 10px !important;\n  text-decoration: none;\n  cursor: pointer;\n  text-transform: uppercase;\n  opacity: 0.7;\n}\n.requestorLink {\n  position: relative;\n  z-index: 11;\n  font-size: 10px !important;\n  cursor: pointer;\n  text-transform: uppercase;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px !important;\n  a {\n    box-shadow: none !important;\n    opacity: 0.7;\n    color: gtGrayDark;\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n    color: gtBlue;\n  }\n}\n\n.requestor {\n  margin-bottom: 6px;\n}\n\n.logTableHeader {\n  font-size: 12px !important;\n  text-transform: uppercase;\n  font-weight: 500;\n  background-color: gtGrayLight !important;\n  color: #31333f !important;\n  padding-bottom: 16px !important;\n  padding-top: 16px !important;\n  padding-left: 20px !important;\n}\n\n.logStyle {\n  width: 10.25rem !important;\n}\n.logStyleCell {\n  font-size: 11px !important;\n  padding: 6px 20px !important;\n  line-height: 16px !important;\n}\n\n.logStyleCellNoPadding {\n  font-size: 11px !important;\n  line-height: 16px !important;\n  padding: 6px 10px !important;\n}\n\n.associatedDrfTitle {\n  font-weight: 600;\n}\n.scheduledDrfTitle {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.associatedDrf {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: textLight;\n}\n.associatedDrfDate {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  p {\n    margin: 6px 0 6px 1px;\n    color: textLight;\n  }\n}\n.requestInfoItem {\n  height: 18px;\n  z-index: 10;\n  position: relative;\n}\n.recurringViewLink {\n  font-size: 12px;\n  z-index: 10;\n  position: relative;\n}\n\n.recurringPaymentWarning {\n  margin-top: 0.6rem;\n  font-size: 11px;\n  color: gtOrangeDark;\n}\n\n.recurringHeader {\n  background-color: gtPurpleAlt !important;\n  h5 {\n    background-color: gtPurpleAlt !important;\n  }\n}\n\n.recurringDistributionSection {\n  background: gtPurpleLight !important;\n}\n\n.requestAmountLabel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  align-items: flex-start;\n}\n\n.secondSignerWarning {\n  color: gtRed;\n  font-weight: 700;\n  font-size: 13px;\n  margin-top: 2rem;\n  margin-bottom: 5rem;\n}\n\n.payNowButton {\n  display: flex;\n  flex-direction: row;\n  p {\n    lost-column: 4/12;\n  }\n  div {\n    lost-column: 8/12;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    button {\n      width: 110px;\n      margin-bottom: 8px;\n      span {\n        font-size: 14px !important;\n      }\n    }\n  }\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    text-align: right;\n  }\n}\n\n.orange {\n  color: gtOrangeDark;\n  font-weight: 700;\n  input {\n    color: gtOrangeDark;\n  }\n}\n\n.red {\n  color: gtRed;\n  font-weight: 700;\n  input {\n    color: gtRed;\n  }\n}\n\n.feeInfoRow {\n  display: flex;\n  gap: 40px;\n  margin-bottom: 24px;\n}\n\n.feeInfoItem {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.feeInfoLabel {\n  font-size: 12px;\n  color: gtGrayDark;\n  margin-bottom: 4px;\n  font-weight: normal;\n}\n\n.feeValue {\n  font-weight: 600;\n  font-size: 16px;\n  color: gtGrayDark;\n  line-height: 1.2;\n}\n\n.enrollmentQuestion {\n  margin-bottom: 16px;\n  font-size: 14px;\n  color: gtGrayDark;\n}\n\n.orange {\n  color: gtOrangeDark;\n  font-weight: 600;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.cardMarginBot .sectionNoMargin {\n  padding: 20px;\n}\n\n.feeInfoRow:last-child {\n  margin-bottom: 0;\n}\n\n.italicTextDeposit {\n  font-style: italic;\n  margin-bottom: 16px;\n  color: gtGrayDark;\n  font-size: 16px;\n  font-family: Georgia, 'Times New Roman', serif;\n}\n\n.rowError {\n  composes: row;\n\n  .error {\n    font-weight: bold;\n    color: gtRed;\n  }\n}\n\n.selectPlaceholder {\n  color: #999999 !important;\n}\n\n.rowError {\n  composes: row;\n  margin-top: 8px;\n  margin-bottom: 0;\n  .error {\n    font-weight: bold;\n    color: gtRed;\n  }\n}\n\n.originalDepositLink {\n  color: gtBlue;\n  font-weight: bold;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.originalDepositLink:hover {\n  color: gtBlueDark;\n}\n\n.recalculateFeeLink {\n  appearance: none;\n  background: none;\n  border: none;\n  padding: 0;\n  margin-top: 16px;\n  font: inherit;\n  font-size: 14px;\n  color: gtBlue;\n  text-decoration: underline;\n  cursor: pointer;\n  line-height: 1.4;\n  align-self: flex-start;\n}\n\n.recalculateFeeLink:hover:not(:disabled) {\n  color: gtBlueDark;\n}\n\n.recalculateFeeLink:disabled {\n  color: gtGrayDark;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.xeroLinks {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtPurpleAlt": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleAlt"]}`,
	"gtOrangeDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]}`,
	"gtPurpleLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleLight"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"contentContainer": `styles__contentContainer___UIHii ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"row": `styles__row___qy7Nz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"caption": `styles__caption___zVg1c`,
	"oneThird": `styles__oneThird___TpNXs`,
	"twoThird": `styles__twoThird___ibPMv`,
	"cardMarginBot": `styles__cardMarginBot___Hx7a1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"section": `styles__section___G1E32 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]}`,
	"subSection": `styles__subSection___VQhjW`,
	"sectionNoMargin": `styles__sectionNoMargin___spFoW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"form": `styles__form___e6O89`,
	"formItem": `styles__formItem___Kd6fV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"formItemHalf": `styles__formItemHalf___EB0OD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]}`,
	"formItemMono": `styles__formItemMono___D6faU`,
	"input": `styles__input___AmTCZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"inputLabelGroup": `styles__inputLabelGroup___VPOrg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"select": `styles__select___ciUxm ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"label": `styles__label___nhKhb ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"labelSecondary": `styles__labelSecondary___smnRd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"radioButtonGroup": `styles__radioButtonGroup___ZOgXE ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"buttons": `styles__buttons___Vo1di`,
	"checkboxVertical": `styles__checkboxVertical___CEkWj`,
	"recurringSection": `styles__recurringSection___ullE7`,
	"submitButtons": `styles__submitButtons___hHfSB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttons"]}`,
	"button": `styles__button___fjSLr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonDanger": `styles__buttonDanger___bBTUr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"searchComponent": `styles__searchComponent___EGwgi`,
	"payTo": `styles__payTo___RRaNe`,
	"payToAddress": `styles__payToAddress___UI3Ab`,
	"name": `styles__name____UahS`,
	"fileUpload": `styles__fileUpload___bqkf2`,
	"fileUploadComponent": `styles__fileUploadComponent___qsW_K`,
	"textInput": `styles__textInput___AbmNc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"textarea": `styles__textarea___vcPZy ${___CSS_LOADER_ICSS_IMPORT_1___.locals["textarea"]}`,
	"textareaSmall": `styles__textareaSmall___YZ5pU ${___CSS_LOADER_ICSS_IMPORT_1___.locals["textarea"]}`,
	"actions": `styles__actions___DmBFt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"actionButton": `styles__actionButton___YsBI3`,
	"distributionFormContainer": `styles__distributionFormContainer___pgrUy ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"sectionOne": `styles__sectionOne___tZ3eS`,
	"sectionTwo": `styles__sectionTwo___pzSZX`,
	"sectionThree": `styles__sectionThree___VfnpU`,
	"sectionThreeTop": `styles__sectionThreeTop___Higqd`,
	"viewDrfSection": `styles__viewDrfSection___TAKXy`,
	"footerContainer": `styles__footerContainer___AgKcW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"notesList": `styles__notesList___UIVK2`,
	"bodyAltPaddingTop": `styles__bodyAltPaddingTop___sMnrI`,
	"logInfo": `styles__logInfo___HeL55 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"logInfoTitle": `styles__logInfoTitle___MPxgW`,
	"logList": `styles__logList___K2IFv`,
	"logInfoWithoutContainer": `styles__logInfoWithoutContainer___d3Mz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"modalButton": `styles__modalButton___Xu4EK`,
	"pendingSectionLayout": `styles__pendingSectionLayout___d7cpD`,
	"pendingSectionHeader": `styles__pendingSectionHeader___s42kz`,
	"checkbox": `styles__checkbox___sYw6N`,
	"radioOption": `styles__radioOption___ch28Q`,
	"submitButtonsJustify": `styles__submitButtonsJustify___ll5ng`,
	"radioClear": `styles__radioClear___vA7n9`,
	"selectedContact": `styles__selectedContact___Vk7FD`,
	"actionsNeededContainer": `styles__actionsNeededContainer___jlgmx`,
	"xeroLinkItem": `styles__xeroLinkItem___b3fR9`,
	"xeroItem": `styles__xeroItem___mmpJf`,
	"xeroRefresh": `styles__xeroRefresh___lH8Q_`,
	"requestorLink": `styles__requestorLink___QqwYW`,
	"requestor": `styles__requestor___EXR28`,
	"logTableHeader": `styles__logTableHeader___MSvl7`,
	"logStyle": `styles__logStyle___wAM1E`,
	"logStyleCell": `styles__logStyleCell___kxO6a`,
	"logStyleCellNoPadding": `styles__logStyleCellNoPadding___edpfq`,
	"associatedDrfTitle": `styles__associatedDrfTitle___Qbpa6`,
	"scheduledDrfTitle": `styles__scheduledDrfTitle___j0Mir`,
	"associatedDrf": `styles__associatedDrf___vExGf`,
	"associatedDrfDate": `styles__associatedDrfDate___k_tGT`,
	"requestInfoItem": `styles__requestInfoItem___HlYUJ`,
	"recurringViewLink": `styles__recurringViewLink___ZOHt2`,
	"recurringPaymentWarning": `styles__recurringPaymentWarning___lcoiH`,
	"recurringHeader": `styles__recurringHeader___uomtJ`,
	"recurringDistributionSection": `styles__recurringDistributionSection___A5ec7`,
	"requestAmountLabel": `styles__requestAmountLabel___LCOF0`,
	"secondSignerWarning": `styles__secondSignerWarning___EvLyf`,
	"payNowButton": `styles__payNowButton___kpWaI`,
	"orange": `styles__orange___SQBmb`,
	"red": `styles__red___nZygY`,
	"feeInfoRow": `styles__feeInfoRow____hnWo`,
	"feeInfoItem": `styles__feeInfoItem___qS8hf`,
	"feeInfoLabel": `styles__feeInfoLabel___X9K15`,
	"feeValue": `styles__feeValue___AS4Sa`,
	"enrollmentQuestion": `styles__enrollmentQuestion___RckoM`,
	"italicTextDeposit": `styles__italicTextDeposit___HuiFX`,
	"rowError": `styles__rowError___ftX0Y styles__row___qy7Nz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]} styles__row___qy7Nz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"error": `styles__error___kfOJW`,
	"selectPlaceholder": `styles__selectPlaceholder___AjMRE`,
	"originalDepositLink": `styles__originalDepositLink___M369J`,
	"recalculateFeeLink": `styles__recalculateFeeLink___h3wcr`,
	"xeroLinks": `styles__xeroLinks___av_4S`
};
export default ___CSS_LOADER_EXPORT___;
